import React, { ChangeEvent, useContext, useEffect, useState } from 'react';
import { Document } from '../../../types/Document';
import { Button, Icon, Table } from 'semantic-ui-react';
import DocumentDownloadService from '../../../services/fetch/DocumentDownload.service';
import { AppContext } from '../../../model/context/app/app';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type KCYDocumentProps = {
    kycDocument: Document | undefined;
};

export default function KYCDocumentRowComponent(props: KCYDocumentProps) {
    const hiddenFileInput = React.useRef(null);
    const documentDownloadService = new DocumentDownloadService();

    const context = useContext(AppContext);
    const { leadId } = useParams();
    const { t } = useTranslation();
    const [token, setToken] = useState('');
    const [kycDocument, setKcyDocument] = useState(props.kycDocument);
    const [downloadDisabled, setDownloadDisabled] = useState(false);

    // @ts-ignore
    const handleClick = () => hiddenFileInput?.current.click();

    const deleteKYCSheet = async () => {
        let resp = await documentDownloadService.deleteKYCSheet(leadId!, token);
        if (resp.status === 200) {
            setKcyDocument(undefined);
        } else {
            console.error('Issue while deleting KYC-sheet', resp.json());
        }
    };

    const download = () => {
        if (kycDocument) {
            documentDownloadService.downloadDocument(token, kycDocument, `${leadId}-KYC-sheet.pdf`);
        }
    };

    async function uploadKYCSheet(e: ChangeEvent<HTMLInputElement>) {
        if (e.target.files) {
            let file = e.target.files[0];
            let resp = await documentDownloadService.uploadKYCDocument(file, leadId!, token);
            if (resp && resp.status === 200) {
                let kycDocument: Document = await resp.json();
                setKcyDocument(kycDocument);
            } else {
                console.error('Issue while uploading KYC-sheet', resp?.json());
            }
        }
    }

    useEffect(() => {
        setDownloadDisabled(!kycDocument);
    }, [kycDocument]);

    useEffect(() => {
        setToken(context.token);
    }, [context]);

    return (
        <Table.Row>
            <Table.Cell singleLine>
                {t('lead.detail.box.documents.DOCUMENT_TYPE_KYC_SHEET')}
                <span style={{ padding: '15px' }}>
                    <Button
                        title={'Download KYC-Sheet'}
                        disabled={downloadDisabled}
                        className="ui small basic icon button"
                        onClick={download}>
                        <Icon name="cloud download" />
                    </Button>
                </span>
            </Table.Cell>
            <Table.Cell>
                <Button
                    title={'Upload KYC-Sheet'}
                    disabled={kycDocument !== undefined}
                    className="ui small basic icon button"
                    onClick={handleClick}>
                    <Icon name="cloud upload" />
                </Button>
                <input
                    type="file"
                    accept={'application/pdf'}
                    onChange={uploadKYCSheet}
                    onClick={(event) => (event.currentTarget.value = '')}
                    hidden={true}
                    ref={hiddenFileInput}
                />
                <Button
                    title={'Delete KYC-Sheet'}
                    className="ui small basic icon button"
                    onClick={deleteKYCSheet}
                    disabled={downloadDisabled}>
                    <Icon name="delete" />
                </Button>
            </Table.Cell>
        </Table.Row>
    );
}
